var _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCashJournalLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 40,
    viewBox: "0 0 52 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.9235 23.1443C32.9235 23.7124 32.8247 24.2413 32.6272 24.7311H23.7185C23.521 24.2413 23.4222 23.7124 23.4222 23.1443C23.4222 20.5583 25.5358 18.423 28.163 18.423C30.7901 18.423 32.9037 20.5387 32.9037 23.1443H32.9235Z",
    fill: "#71C6FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46 15.2689V29.1193C46 30.1576 45.1506 31 44.1037 31H10.7407V24.7311H41.2395V15.2689H46Z",
    fill: "#71C6FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6272 24.7311C31.9951 26.553 30.237 27.8655 28.163 27.8655C26.0889 27.8655 24.3506 26.5726 23.6988 24.7311L32.6272 24.7311Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2593 15.2689V24.7115H32.6469C32.8444 24.2217 32.9432 23.6928 32.9432 23.1247C32.9432 20.5387 30.8296 18.4034 28.2025 18.4034C25.5753 18.4034 23.4617 20.5191 23.4617 23.1247C23.4617 23.6928 23.5605 24.2217 23.758 24.7115H10.7407V15.2689H41.2395H41.2593Z",
    fill: "url(#paint0_linear_125_36312)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2593 9V15.2689H10.7407V24.7115H6V10.8807C6 9.84239 6.84938 9 7.8963 9H41.2593Z",
    fill: "#71C6FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4222 21.577C26.0514 21.577 28.1827 19.4632 28.1827 16.8557C28.1827 14.2483 26.0514 12.1345 23.4222 12.1345C20.7931 12.1345 18.6617 14.2483 18.6617 16.8557C18.6617 19.4632 20.7931 21.577 23.4222 21.577Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_125_36312",
    x1: 6,
    y1: 20,
    x2: 46,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0455A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#208AF2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashJournalLogo);
export default __webpack_public_path__ + "static/media/cash_journal_logo.1dfa8210de4fc3ee737094b20c096c16.svg";
export { ForwardRef as ReactComponent };